export { default } from "./TextConfigSection";
